import React from 'react';
import { Box, Flex, Image, Link, Button } from '@chakra-ui/react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { LuLogOut } from 'react-icons/lu';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';
import { NavigationContent } from './NavigationContent';
import { getNavigationForUser } from './navigationConfig';

export const Sidebar: React.FC = () => {
  const { user, logout } = useAuth();

  if (!user) return null;

  const isAdmin = user.role === 'admin';
  const navigation = getNavigationForUser(isAdmin);

  const openHelp = () => window.open('https://aide.opentri.fr', '_blank', 'noreferrer,noopener');

  return (
    <Box
      as="nav"
      position="static"
      top={0}
      left={0}
      height="100vh"
      width="15%"
      bg="#050e3a"
      color="white"
      zIndex={2}
      px={2}
      display={{ base: 'none', xl: 'flex' }}
      flexDirection="column"
      css={{ "@media print": { display: "none" } }}
    >
      <Flex direction="column" h="100%" justify="space-between" py={6}>
        {/* Logo */}
        <Box p={4}>
          <Flex justify="space-between" align="center" mb={12}>
            <Link asChild>
              <RouterLink to="/dashboard">
                <Image src="/opentri-white.png" maxH={48} />
              </RouterLink>
            </Link>
          </Flex>

          {/* Navigation */}
          <NavigationContent sections={navigation} />
        </Box>

        {/* Footer */}
        <Flex px={4} mt={8} direction="column" gap={2}>
          <Button
            variant="ghost"
            color="white"
            _hover={{ color: 'blue.800' }}
            justifyContent="flex-start"
            width="100%"
            onClick={openHelp}
          >
            <QuestionMarkCircleIcon style={{ marginRight: '12px', width: '20px', height: '20px' }} />
            Besoin d'aide ?
          </Button>

          <Button
            variant="ghost"
            color="white"
            _hover={{ color: 'blue.800' }}
            justifyContent="flex-start"
            width="100%"
            onClick={logout}
          >
            <LuLogOut style={{ marginRight: '12px', width: '20px', height: '20px' }} />
            Se déconnecter
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};
